import { Box, Link, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { env } from '@app/config/env';

/**
 * Application Footer
 *
 * Minimal footer for government ERP with:
 * - Copyright notice
 * - Essential links (Support, Privacy, Terms) - translated
 * - Responsive layout (stacked on mobile, horizontal on desktop)
 *
 * Note: Footer is placed inside the main content area (not full-width)
 * so it follows the content Card and doesn't go behind the sidebar.
 */
export const Footer = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: { xs: 2, sm: 3 },
        mt: 2,
        bgcolor: 'transparent',
      }}
    >
      {isMobile ? (
        // Mobile: Stacked layout
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          <Typography variant="body2" color="text.secondary" align="center">
            © {currentYear} {env.app.name}. {t('footer.allRightsReserved')}
          </Typography>
        </Box>
      ) : (
        // Desktop: Horizontal layout
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* Left: Copyright */}
          <Typography variant="body2" color="text.secondary">
            © {currentYear} {env.app.name}. {t('footer.allRightsReserved')}
          </Typography>

          {/* Center: Links */}
          <Box display="flex" gap={3}>
            <Link
              href="#/support"
              color="text.secondary"
              underline="hover"
              variant="body2"
              sx={{ cursor: 'pointer' }}
            >
              {t('footer.support')}
            </Link>
            <Link
              href="#/privacy"
              color="text.secondary"
              underline="hover"
              variant="body2"
              sx={{ cursor: 'pointer' }}
            >
              {t('footer.privacyPolicy')}
            </Link>
            <Link
              href="#/terms"
              color="text.secondary"
              underline="hover"
              variant="body2"
              sx={{ cursor: 'pointer' }}
            >
              {t('footer.termsOfUse')}
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  );
};

